import type { GossipItem } from "@/mocks/gossip";

interface ColumnDef {
  key: string;
  title: string;
  desc: string;
  icon: string;
  tone: string;
  iconTone: string;
}

const columns: ColumnDef[] = [
  {
    key: "xing",
    title: "明星动态",
    desc: "行程·营业·日常，明星的一举一动都在这里。",
    icon: "ri-star-smile-line",
    tone: "bg-primary-100",
    iconTone: "text-primary-600",
  },
  {
    key: "zongyi",
    title: "影视综艺",
    desc: "剧集口碑、综艺名场面、幕后细节一键补全。",
    icon: "ri-tv-2-line",
    tone: "bg-accent-100",
    iconTone: "text-accent-700",
  },
  {
    key: "bagua",
    title: "圈内八卦",
    desc: "独家线索与多方信源交叉，理性吃瓜必备。",
    icon: "ri-chat-history-line",
    tone: "bg-secondary-100",
    iconTone: "text-secondary-700",
  },
  {
    key: "hongtan",
    title: "红毯现场",
    desc: "星光、造型与救场名场面，逐帧帮你回顾。",
    icon: "ri-goblet-fill",
    tone: "bg-foreground-950",
    iconTone: "text-accent-400",
  },
];

interface Props {
  items: GossipItem[];
  onSelect: (key: string) => void;
}

export default function ColumnStrip({ items, onSelect }: Props) {
  const countOf = (key: string) => items.filter((i) => i.categoryKey === key).length;

  return (
    <section id="column" className="mx-auto max-w-[1440px] scroll-mt-20 px-4 pb-10 pt-6 md:px-8 md:pb-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 text-sm font-semibold text-accent-700">
            <i className="ri-archive-line text-base" aria-hidden="true"></i>
            COLUMNS
          </p>
          <h2 className="mt-2 text-3xl font-bold text-foreground-950 md:text-4xl">瓜棚栏目</h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">认准栏目下手，哪里热闹点哪里，直达你最爱的那口瓜。</p>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {columns.map((col) => (
          <button
            key={col.key}
            type="button"
            onClick={() => onSelect(col.key)}
            className="group relative flex flex-col overflow-hidden rounded-3xl bg-background-100 p-6 text-left transition-all duration-300 hover:-translate-y-1"
          >
            <span
              className={`grid h-12 w-12 place-items-center rounded-2xl ${col.tone} ${col.iconTone}`}
            >
              <i className={`${col.icon} text-2xl leading-none`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 flex items-center gap-2 text-lg font-semibold text-foreground-950">
              {col.title}
              <span className="rounded-full bg-background-50 px-2 py-0.5 text-[11px] font-medium text-foreground-500">
                {countOf(col.key)} 条
              </span>
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition-colors group-hover:text-primary-700">
              进棚逛逛
              <i className="ri-arrow-right-line text-base leading-none transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}